import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import 'react-widgets/dist/css/react-widgets.css';
import {Combobox} from 'react-widgets';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from 'jsx/elements/buttons/Button';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '450px',
    height: '400px',
    maxWidth: '90%',
    maxHeight: '90%'
  }
};

const parentDiv = {
  position : 'relative',
};

const childDiv = {
  position : 'absolute',
  width : '90%',
  bottom : 20,
  left : 20,
};


class FileLoadModal extends Component {
  state = {
    isOpen : false,
    claimID : 0,    
    tabIndex : 2,
    file : undefined
  };
  constructor(props){
    super(props);
    this.fileUpload = this.fileUpload.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onAcceptCloseModal = this.onAcceptCloseModal.bind(this);
    this.onNumberChange = this.onNumberChange.bind(this);
  }

  onAcceptCloseModal(){
    switch(this.state.tabIndex){
      case 0:
        this.props.onAcceptFile(0, this.state.claimID);
        break;
      case 1:
        this.props.onAcceptFile(1, this.state.claimID);
        break;
      case 2:
        this.props.onAcceptFile(2, this.state.file );
        break;
      default:
        break;
    }
  }

  fileUpload(e) {
    this.setState({file:e.target.files[0]});
  }


  onHandleTextChange(text){
    this.setState({ claimID: text });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ isOpen: nextProps.isOpen });
  }

  onChange(item) {
    console.log("Value selected", item);
    this.setState({ claimID: item.itemID });
  }

  onNumberChange(event){
    console.debug("number", event.target.value);
    this.setState({ claimID: event.target.value });
  }

  checkIfInputIsValid(){
    if ((this.state.tabIndex === 0) && (this.state.claimID > 0)){
      return true;
    }
    if ((this.state.tabIndex === 1) && (this.state.claimID > 0)){
      return true;
    }
    if ((this.state.tabIndex === 2) && (this.state.file !== undefined)){
      return true;
    }
    return false;
  }

  render() {

    //const baseUrl = process.env.REACT_APP_ILWEB_API_URL + '/calculator/upload';


    const topModal = (
      <div className="grid collapse840">
        <div className="col s1of4 text-left">
          <h2>Opna mál</h2>
        </div>
        <div className="col s3of4 text-right">
          <h6>Vinsamlegast veljið mál til að opna</h6>
        </div>
      </div>
    );

    const middleModal = (
      <div>
        <Tabs selectedIndex={this.state.tabIndex} onSelect={tabIndex => this.setState({ tabIndex })}>
          <TabList>
            <Tab>ClaimID</Tab>
            <Tab>Claimnumber</Tab>
            <Tab>File</Tab>
          </TabList>
          <TabPanel>
            <div className="grid tight collapse840">
              <div className="col">
                <div className="calc-div-inline calc-div-inline-space">
                   <input id="claimID" type="number" onChange={this.onNumberChange} value={this.state.claimID} pattern="[0-9]*"/>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
             <Combobox data={this.props.claimList}  textField='name' onSelect={this.onChange} suggest={true}/>
          </TabPanel>
          <TabPanel>
            <div className="grid tight collapse840">
              <div className="col">
                <input type="file" accept=".cpk" onChange={this.fileUpload} />
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </div>
  );

    const bottomModel = (
      <div style={childDiv}>
        <div className="grid collapse840">
          <div className="col s1of4 text-left">
            <Button color={'blue'} className="getclaimnumber-button" text="Hætta við" onClick={this.props.onCloseModal} />
          </div>
          <div className="col s3of4 text-right">
            {this.checkIfInputIsValid() && <Button color={'blue'} className="getclaimnumber-button" text="Opna mál" onClick={this.onAcceptCloseModal} />}
          </div>
        </div>
      </div>
    );


    return (
      <div style={parentDiv}>
        <ReactModal
          // className='content'
          // overlayClassName='overlay'
          style={modalStyles}
          isOpen={this.state.isOpen}
          contentLabel="Modal"
          onRequestClose={this.props.onCloseModal}
          shouldCloseOnOverlayClick={false}>
          <div>
            {topModal}
            {middleModal}
            {bottomModel}
          </div>
        </ReactModal>
      </div>
    );
  }
}

FileLoadModal.propTypes = {
  isOpen : PropTypes.bool.isRequired,
  onAcceptFile : PropTypes.func,
  onCloseModal : PropTypes.func,
  claimList: PropTypes.array,
};

export default FileLoadModal;





// WEBPACK FOOTER //
// ./src/pages/Calculation/Modals/FileLoadModal.js